import React, { useState, useEffect } from "react";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  Polyline,
} from "@react-google-maps/api";
import { imageUrlOthers } from "../../services/CommonUrl";
import pdfImg from "../../assets/images/pdf.png";
import {
  getIconForDaysType,
  getMarkerIconForLocationType,
  getSmallIconForDaysType,
} from "../icon-days-type";

function GoogleMapComponent(props) {
  const isPDF = (file) => typeof file === "string" && /\.pdf$/i.test(file);
  const [activeMarker, setActiveMarker] = useState(null);
  const [waypoints, setwaypoints] = useState([]);
  const [itineraryDayDetails, setItineraryDayDetails] = useState([]);

  useEffect(() => {
    // console.log("Running", props.days)
    setItineraryDayDetails(props.days);
    let wayPointArr = [];
    props.days.forEach((day) => {
      if (day?.from_address?.location?.coordinates) {
        wayPointArr.push({
          lat: day?.from_address?.location?.coordinates[0],
          lng: day?.from_address?.location?.coordinates[1],
        });
      }

      if (day?.to_address?.location?.coordinates) {
        wayPointArr.push({
          lat: day?.to_address?.location?.coordinates[0],
          lng: day?.to_address?.location?.coordinates[1],
        });
      }

      if (day?.location?.coordinates) {
        wayPointArr.push({
          lat: day?.location?.coordinates[0],
          lng: day?.location?.coordinates[1],
        });
      }
    });
    setwaypoints(wayPointArr);
  }, []);

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const handleOnLoad = (map) => {
    const bounds = new window.google.maps.LatLngBounds();
    props.days?.forEach((item) => {
      const position = item?.from_address?.location?.coordinates
        ? {
          lat: item?.from_address?.location?.coordinates[0],
          lng: item?.from_address?.location?.coordinates[1],
        }
        : item?.to_address?.location?.coordinates
          ? {
            lat: item?.to_address?.location?.coordinates[0],
            lng: item?.to_address?.location?.coordinates[1],
          }
          : item?.location?.coordinates
            ? {
              lat: item?.location?.coordinates[0],
              lng: item?.location?.coordinates[1],
            }
            : null;

      if (position) {
        bounds.extend(position);
      }
    });
    if (!bounds.isEmpty()) {
      map.fitBounds(bounds);
    }
  };

  return itineraryDayDetails && (
    <GoogleMap
      onLoad={handleOnLoad}
      onClick={() => setActiveMarker(null)}
      mapContainerStyle={props.mapContainerStyle}
      options={{ ...props.options }}
    >
      <Polyline
        geodesic={true}
        path={waypoints}
        options={{
          strokeColor: "#004aad",
          strokeOpacity: 0.75,
          strokeWeight: 2,
        }}
      />
      {props.days
        .sort((a, b) => b.time - a.time)
        .map((item, index) => {
          const positions = [];
          if (item?.from_address?.location?.coordinates) {
            positions.push({
              id: item?._id + 1,
              lat: item?.from_address?.location?.coordinates[0],
              lng: item?.from_address?.location?.coordinates[1],
              address: item?.from_address?.formatted_address,
            });
          }
          if (item?.to_address?.location?.coordinates) {
            positions.push({
              id: item?._id + 2,
              lat: item?.to_address?.location?.coordinates[0],
              lng: item?.to_address?.location?.coordinates[1],
              address: item?.to_address?.formatted_address,
            });
          }
          if (item?.location?.coordinates) {
            positions.push({
              id: item?._id,
              lat: item?.location?.coordinates[0],
              lng: item?.location?.coordinates[1],
              address: item?.address,
            });
          }

          return positions.map((position, posIndex) => (
            <Marker
              key={`${item?._id}-${posIndex}`}
              position={{ lat: position?.lat, lng: position?.lng }}
              //label= {`${index+1}`}
              animation={window.google.maps.Animation.DROP}
              label={{
                text: `${index + 1}`,
                color: "#fff",
                fontSize: "10px",
                //fontWeight: "bold",
                className: "marker-label-position",
              }}
              icon={getMarkerIconForLocationType(
                item?.days_type,
                item?.types[0]
              )}
              onClick={() => handleActiveMarker(position?.id)}
              onMouseOver={() => handleActiveMarker(position?.id)}
              onMouseOut={() => setActiveMarker(null)}
            >
              {activeMarker === position?.id ? (
                <InfoWindow onCloseClick={() => setActiveMarker(null)}>
                  <div>
                    <div className="llp-item">
                      <div className="civ-item-img">
                        {item?.icon?.length == 0 ? (
                          <img
                            src={getIconForDaysType(
                              item?.days_type,
                              item?.types[0]
                            )}
                            alt={item?.days_type || "Icon"}
                          />
                        ) : (
                          <img
                            src={
                              isPDF(item?.icon[0])
                                ? pdfImg
                                : imageUrlOthers + item?.icon[0]
                            }
                            alt={item?.days_type || "Icon"}
                          />
                        )}
                      </div>
                      <div className="civ-item-info">
                        <div className="civ-item-icon-check">
                          <span>
                            <img
                              src={getSmallIconForDaysType(
                                item?.days_type,
                                item?.types[0]
                              )}
                              alt={item?.days_type || "Icon"}
                              width={12}
                            />
                            {item?.days_type === "Transports"
                              ? item?.types[0]
                              : item?.days_type}
                          </span>
                        </div>
                        <h5>{item?.name}</h5>
                        <p>{position?.address}</p>
                      </div>
                    </div>
                  </div>
                </InfoWindow>
              ) : null}
            </Marker>
          ));
        })}
    </GoogleMap>
  );
}

export default React.memo(GoogleMapComponent);
